const lang = {
    /** 彩票語言包 */
    '请输入': {
        'zh_TW': '請輸入',
        'en_US': 'Please enter ',
    },
    '错误': {
        'zh_TW': '錯誤',
        'en_US': 'Error',
    },
    '结果': {
        'zh_TW': '結果',
        'en_US': 'Data',
    },
    '金额': {
        'zh_TW': '金額',
        'en_US': 'Amount',
    },
    '欢迎回来': {
        'zh_TW': '歡迎回來',
        'en_US': 'Welcome',
    },
    '余额': {
        'zh_TW': '餘額',
        'en_US': 'Balance',
    },
    '游戏规则': {
        'zh_TW': '遊戲規則',
        'en_US': 'Game rules',
    },
    '网站公告': {
        'zh_TW': '網站公告',
        'en_US': 'Bulletin',
    },
    '开奖记录': {
        'zh_TW': '開獎紀錄',
        'en_US': 'Draw History',
    },
    '历史投注': {
        'zh_TW': '歷史投注',
        'en_US': 'Bet History',
    },
    '搜寻': {
        'zh_TW': '搜尋',
        'en_US': 'Search',
    },
    '路子': {
        'zh_TW': '路子',
        'en_US': 'Rank',
    },
    '注单编号/时间': {
        'zh_TW': '注單編號/時間',
        'en_US': 'Order Number/Time',
    },
    '投注内容': {
        'zh_TW': '投注内容',
        'en_US': 'Bet Result',
    },
    '内容': {
        'zh_TW': '内容',
        'en_US': 'Content',
    },
    '时时彩': {
        'zh_TW': '時時彩',
        'en_US': 'Shi5',
    },
    '赛车/飞艇/赛马': {
        'zh_TW': '賽車/飛艇/賽馬',
        'en_US': 'Pk10/Boat/Hourse',
    },
    '宾果': {
        'zh_TW': '賓果',
        'en_US': 'Bingo',
    },
    '11选5': {
        'zh_TW': '11選5',
        'en_US': 'Five11',
    },
    '期号': {
        'zh_TW': '期號',
        'en_US': 'Draw Numbe',
    },
    '最新开奖结果': {
        'zh_TW': '最新開獎結果',
        'en_US': 'Latest Draw Result',
    },
    '开奖查询': {
        'zh_TW': '開獎查詢',
        'en_US': 'Lottery query',
    },
    '最后购买时间': {
        'zh_TW': '最後購買時間',
        'en_US': 'Time until purchase',
    },
    '正在开奖': {
        'zh_TW': '正在開獎',
        'en_US': 'Now Drawing',
    },
    '剩余': {
        'zh_TW': '剩餘',
        'en_US': 'Remaining',
    },
    '本日已开': {
        'zh_TW': '本日已開',
        'en_US': 'Past Draw Today',
    },
    '投注': {
        'zh_TW': '投注',
        'en_US': 'Bet',
    },
    '赔率': {
        'zh_TW': '賠率',
        'en_US': 'Odds',
    },
    '小计': {
        'zh_TW': '小計',
        'en_US': 'Subtotal',
    },
    '奖金': {
        'zh_TW': '獎金',
        'en_US': 'Prize',
    },
    '您的投注': {
        'zh_TW': '您的投注',
        'en_US': 'Your Bets',
    },
    '收起注单': {
        'zh_TW': '收起注單',
        'en_US': 'Open',
    },
    '展开注单': {
        'zh_TW': '展開注單',
        'en_US': 'Close',
    },
    '清除下注': {
        'zh_TW': '清除下注',
        'en_US': 'Clear Bet',
    },
    '确认': {
        'zh_TW': '確認',
        'en_US': 'Confirm',
    },
    '取消': {
        'zh_TW': '取消',
        'en_US': 'Cancel',
    },
    '确认投注': {
        'zh_TW': '確認投注',
        'en_US': 'Confirm Betting',
    },
    '请选择投注内容': {
        'zh_TW': '請選擇投注内容',
        'en_US': 'Please select betting content',
    },
    '起始时间': {
        'zh_TW': '起始時間',
        'en_US': 'Start Date',
    },
    '结束时间': {
        'zh_TW': '結束時間',
        'en_US': 'Stop Date',
    },
    '期号/时间': {
        'zh_TW': '期號/時間',
        'en_US': 'Draw No./Time',
    },
    '输赢': {
        'zh_TW': '輸贏',
        'en_US': 'Win/Loss',
    },
    '注数': {
        'zh_TW': '注數',
        'en_US': 'Count',
    },
    '关闭': {
        'zh_TW': '關閉',
        'en_US': 'Close',
    },
    '一位': {
        'zh_TW': '一位',
        'en_US': '1st Num',
    },
    '二位': {
        'zh_TW': '二位',
        'en_US': '2st Num',
    },
    '三位': {
        'zh_TW': '三位',
        'en_US': '3st Num',
    },
    '四位': {
        'zh_TW': '四位',
        'en_US': '4st Num',
    },
    '五位': {
        'zh_TW': '五位',
        'en_US': '5st Num',
    },
    '六位': {
        'zh_TW': '六位',
        'en_US': '6st Num',
    },
    '七位': {
        'zh_TW': '七位',
        'en_US': '7st Num',
    },
    '八位': {
        'zh_TW': '八位',
        'en_US': '8st Num',
    },
    '九位': {
        'zh_TW': '九位',
        'en_US': '9st Num',
    },
    '十位': {
        'zh_TW': '十位',
        'en_US': '10st Num',
    },
    '大/小': {
        'zh_TW': '大/小',
        'en_US': 'Big/Small',
    },
    '单/双': {
        'zh_TW': '單/雙',
        'en_US': 'Odd/Even',
    },
    '龙/虎': {
        'zh_TW': '龍/虎',
        'en_US': 'Dragon/Tiger',
    },
    '上下分布': {
        'zh_TW': '上下分佈',
        'en_US': 'Up/Down Composition',
    },
    '单双分布': {
        'zh_TW': '單雙分佈',
        'en_US': 'Odd/Even Composition',
    },
    '大小单双': {
        'zh_TW': '大小單雙',
        'en_US': 'Big/Small/Odd/Even',
    },
    '五元素': {
        'zh_TW': '五元素',
        'en_US': 'Five Elements',
    },
    '中位数': {
        'zh_TW': '中位數',
        'en_US': 'Name Mid',
    },
    '前三连': {
        'zh_TW': '前三連',
        'en_US': 'First 3 Num',
    },
    '中三连': {
        'zh_TW': '中三連',
        'en_US': 'Mid 3 Num',
    },
    '末三连': {
        'zh_TW': '末三連',
        'en_US': 'Last 3 Num',
    },
    '1中1': {
        'zh_TW': '1中1',
        'en_US': '1 match 1',
    },
    '2中2': {
        'zh_TW': '2中2',
        'en_US': '2 match 2',
    },
    '4中4': {
        'zh_TW': '4中4',
        'en_US': '4 match 4',
    },
    '5中5': {
        'zh_TW': '5中5',
        'en_US': '5 match 5',
    },
    '6中5': {
        'zh_TW': '6中5',
        'en_US': '6 match 5',
    },
    '7中5': {
        'zh_TW': '7中5',
        'en_US': '7 match 5',
    },
    '8中5': {
        'zh_TW': '8中5',
        'en_US': '8 match 5',
    },
    '万位': {
        'zh_TW': '萬位',
        'en_US': '10Ks',
    },
    '千位': {
        'zh_TW': '千位',
        'en_US': '1Ks',
    },
    '百位': {
        'zh_TW': '百位',
        'en_US': '100s',
    },
    '十位': {
        'zh_TW': '十位',
        'en_US': 'Tens',
    },
    '个位': {
        'zh_TW': '個位',
        'en_US': 'Ones',
    },
    '大': {
        'zh_TW': '大',
        'en_US': 'B',
    },
    '小': {
        'zh_TW': '小',
        'en_US': 'S',
    },
    '单': {
        'zh_TW': '單',
        'en_US': 'O',
    },
    '双': {
        'zh_TW': '雙',
        'en_US': 'E',
    },
    '清': {
        'zh_TW': '清',
        'en_US': 'C',
    },
    '质': {
        'zh_TW': '質',
        'en_US': 'P',
    },
    '合': {
        'zh_TW': '合',
        'en_US': 'C',
    },
    '龙': {
        'zh_TW': '龍',
        'en_US': 'D',
    },
    '虎': {
        'zh_TW': '虎',
        'en_US': 'T',
    },
    '和': {
        'zh_TW': '和',
        'en_US': 'Tie',
    },
    '冠军': {
        'zh_TW': '冠軍',
        'en_US': '1st',
    },
    '亚军': {
        'zh_TW': '亞軍',
        'en_US': '2nd',
    },
    '季军': {
        'zh_TW': '季軍',
        'en_US': '3rd',
    }
    ,
    '4名': {
        'zh_TW': '4名',
        'en_US': '4th',
    }
    ,
    '5名': {
        'zh_TW': '5名',
        'en_US': '5th',
    },
    '6名': {
        'zh_TW': '6名',
        'en_US': '6th',
    },
    '7名': {
        'zh_TW': '7名',
        'en_US': '7th',
    },
    '8名': {
        'zh_TW': '8名',
        'en_US': '8th',
    },
    '9名': {
        'zh_TW': '9名',
        'en_US': '9th',
    },
    '10名': {
        'zh_TW': '10名',
        'en_US': '10th',
    },
    '遗漏号码': {
        'zh_TW': '遗漏號碼',
        'en_US': 'Missing Number',
    },
    '近100期': {
        'zh_TW': '近100期',
        'en_US': 'Last 100',
    },
    '分析': {
        'zh_TW': '分析',
        'en_US': 'Analysis',
    },
    '号码': {
        'zh_TW': '號碼',
        'en_US': 'Number',
    },
    '五球和': {
        'zh_TW': '五球和',
        'en_US': 'All 5 Sum',
    },
    '前三和': {
        'zh_TW': '前三和',
        'en_US': 'First 3 Sum',
    },
    '中三和': {
        'zh_TW': '中三和',
        'en_US': 'Mid 3 Sum',
    },
    '后三和': {
        'zh_TW': '後三和',
        'en_US': 'Last 3 Sum',
    },
    '选择您要搜寻的类型': {
        'zh_TW': '選擇您要搜索的類型',
        'en_US': 'Choose the type you want to search',
    }
    ,
    '排名': {
        'zh_TW': '排名',
        'en_US': 'Rank',
    }
    ,
    '分布': {
        'zh_TW': '分佈',
        'en_US': 'Composition',
    }
    ,
    '合计': {
        'zh_TW': '合計',
        'en_US': 'Sum',
    }
    ,
    '上': {
        'zh_TW': '上',
        'en_US': 'U',
    }
    ,
    '中': {
        'zh_TW': '中',
        'en_US': 'M',
    }
    ,
    '下': {
        'zh_TW': '下',
        'en_US': 'D',
    }
    ,
    '金': {
        'zh_TW': '金',
        'en_US': 'M',
    },
    '木': {
        'zh_TW': '木',
        'en_US': 'W',
    },
    '水': {
        'zh_TW': '水',
        'en_US': 'W',
    },
    '火': {
        'zh_TW': '火',
        'en_US': 'F',
    },
    '土': {
        'zh_TW': '土',
        'en_US': 'E',
    },
    '五球总和': {
        'zh_TW': '五球總和',
        'en_US': '5 Ball Sum',
    }
    ,
    '五球分析': {
        'zh_TW': '五球分析',
        'en_US': '5 Ball Analysis',
    }
    ,
    '三连': {
        'zh_TW': '三连',
        'en_US': 'Near 3 Num',
    }
    ,
    '顺': {
        'zh_TW': '順',
        'en_US': 'S',
    },
    '半': {
        'zh_TW': '半',
        'en_US': 'H',
    },
    '新': {
        'zh_TW': '新',
        'en_US': 'R',
    },
    '停止下注': {
        'zh_TW': '停止下注',
        'en_US': 'Bet Stop',
    }




}


export default lang;


// WEBPACK FOOTER //
// ./src/utils/i18n.js